import { IssueStatusEnum } from '../types';
export const ISSUE_STATUS_VARIANT_MAPPING = {
    [IssueStatusEnum.Suggested]: 'purple',
    [IssueStatusEnum.Resolved]: 'green',
    [IssueStatusEnum.Skipped]: 'yellow',
    [IssueStatusEnum.DismissedByTech]: 'gray',
    [IssueStatusEnum.DismissedByBackOffice]: 'blue',
    [IssueStatusEnum.Detected]: 'red',
    [IssueStatusEnum.CorrectionSuggested]: 'purple',
    // IP-14540: informational/FYI — distinct from the actionable detected (red)
    // and suggestion (purple) styles.
    [IssueStatusEnum.Notification]: 'pink'
};
export function getVariantByStatus(status) {
    const mapping = ISSUE_STATUS_VARIANT_MAPPING[status];
    return mapping || 'red';
}
